import Head from 'next/head';
import Link from 'next/link';

import LogoIcon from '@/icons/LogoIcon';

const Maintenance = () => {
  return (
    <>
      <Head>
        <title>Dealls | Maintenance</title>
      </Head>

      <main className="relative flex h-screen w-full  items-center bg-violet-500">
        <div className="absolute inset-x-0 top-8 w-full px-4 py-8 lg:px-8 lg:py-2">
          <div className="mx-auto w-full max-w-[1440px]">
            <Link href="/" passHref>
              <LogoIcon />
            </Link>
          </div>
        </div>
        <div className="mx-auto max-w-[918px] px-5 lg:px-0">
          <h1
            className="text-4xl font-bold text-white"
            style={{
              textShadow:
                '-1px -1px 0 #1A1A1A, 0px -1px 0 #1A1A1A, 0px 3px 0 #1A1A1A, 3px 3px 0 #1A1A1A, 3px 3px 0px #000000',
            }}
          >
            Maintenance
          </h1>

          <p className="mt-[23px] flex flex-col gap-4 leading-[33px] text-white lg:gap-8 lg:text-[22px]">
            Dear Employers,
            <br />
            <br />
            We&apos;re making some updates to bring you an even better
            experience. While we work on these improvements, our service will be
            temporarily unavailable. <br />
            We apologize for any inconvenience this may cause, but we want to
            assure you that the updates will be worth the wait. <br />
            We appreciate your understanding and patience during this time and
            we can&apos;t wait for you to see the enhancements! Thank you,
            <br /> <br /> Dealls
          </p>
        </div>
      </main>
    </>
  );
};

export default Maintenance;
